import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V2QuoteModuleComponent } from './standard/code-split/v2-quote-module-component';
import {useBexApi} from "@shared-ui/bex-api-context";
import {checkValue} from "src/components/common/helper";
import {V2QuoteWithSigninModuleComponent} from "./v2-quote-with-signin-module/code-split/v2-quote-with-signin-module-component";

// Css Style Import
import(/* webpackChunkName: "v2-quote-module-styles" */ 'src/components/common/modules/v2/v2-quote-module/styles/v2-quote-module.css');
import(/* webpackChunkName: "v1-quote-signin-styles" */ 'src/components/common/modules/v2/v2-quote-module/v2-quote-with-signin-module/styles/v2-quote-with-signin-module.css');

const V2QuoteModule: React.FC<ComponentLayoutType<any>> = (props) => {
  const loadQuoteModule = (isLoginCheck: boolean = false,hideAfterSignIn: boolean = false) => {
    const { context } = useBexApi();
    const expediaUserId = context?.identity?.expUserId;
    const authState = context?.identity?.authState;

    if (
      (!hideAfterSignIn &&
        (!isLoginCheck ||
          authState === "AUTHENTICATED" ||
          (checkValue(expediaUserId) && expediaUserId !== "-1"))) ||
      (hideAfterSignIn &&
        !isLoginCheck &&
        (authState === "ANONYMOUS" ||
          !checkValue(expediaUserId) ||
          expediaUserId === "-1"))
    ) {
      return <V2QuoteModuleComponent />;
    } else if (
      isLoginCheck &&
      (authState === "ANONYMOUS" ||
        !checkValue(expediaUserId) ||
        expediaUserId === "-1")
    ) {
      return <V2QuoteWithSigninModuleComponent />;
    } else {
      return null;
    }    
   
  };
 
  return (
    <>
      {checkValue(props) &&
        checkValue(props?.data) &&   
       ( <ComponentLayout {...props}>
            {loadQuoteModule(props?.data?.requireSignIn === 'True',props?.data?.hideAfterSignIn === 'True')}
        </ComponentLayout> )    
        }
    </>
  );
};

export default V2QuoteModule;
